import { createStyles } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import color from '@material-ui/core/colors/yellow';

export const styles = (theme: Theme) => createStyles({
	headerActions: {
		textAlign: 'right',
		marginLeft: '-57px'
	},
	vertHeaderActions: {
		textAlign: 'center',
		marginLeft: '-8px'
	},
	createContentButton: {
		marginRight: theme.spacing.unit * 4,
	},
	headerTitle: {
		textAlign: 'center',
		marginLeft: '-6px'
	}, root: {
		flexShrink: 0,
		color: theme.palette.text.secondary,
	},
	iconButton: {
		padding: theme.spacing.unit / 4
	},
	progress: {
		margin: theme.spacing.unit * 2,
	},
	leftDisplay: {
		marginLeft: theme.spacing.unit * 4,
	},
	textBar: {
		textAlign: "center"
	},
	subScriptFont: {
		fontSize: "12px"
	},
	textSize: {
		fontSize: '14px'
	},
	textBold: {
		fontWeight: 'bold'
	},
	textEllipsis: {
		width: '100%',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
		paddingRight: theme.spacing.unit
	},
	subTitle: {
		display: 'inline-block',
		lineHeight: theme.spacing.unit * 3 + "px",
	},
	linearProgressBox: {
		height: '35px',
		width: '370px',
		border: '1px solid #DDDDDD',
		borderRadius: '30px',
		marginTop: '40px',
		paddingLeft: '6px',
		paddingRight: '6px',
		fontSize: '10px',
	},
	linearProgressBar: {
		marginTop: '-12px',
		width: '148px',
		marginLeft: '0px'
	},
	previewButton: {
		background: theme.palette.common.white,
		border: '1px solid #DDDDDD',
		fontWeight: 'normal',
		width: '93px',
		boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.0519701)',
		padding: theme.spacing.unit,
		opacity: 0.7,
		'& svg': {
			marginRight: theme.spacing.unit
		}
	},
	viewDetails: {
		opacity: 0.7,
		fontSize: '14px',
		paddingLeft: '12px',
		color: theme.palette.text.secondary
	},
	previewBtn: {
		float: 'right'
	},
	textValue: {
		margin: '5px 5px 0px',
	},
	icon: {
		margin: '-4px 147px 0px',
		fontSize: '18px'
	},
	wrapperMain: {
		height: "auto",
		backgroundColor: theme.palette.common.white,
		fontSize: "12px"
	},
	wrapperCollap: {
		height: "auto",
		paddingRight: "10px",
		paddingLeft: "10px",
		fontSize: "12px"
	},
	marginTop20: {
		marginTop: theme.spacing.unit * 2
	},
	marginBottom20: {
		marginBottom: theme.spacing.unit * 2
	},
	marginTop10: {
		marginTop: theme.spacing.unit
	},
	searchWrapper: {
		paddingTop: "15px",
		paddingLeft: "10px",
		paddingRight: "10px",
		paddingBottom: "15px",
	},
	link: { fontSize: "12px", color: "#2196F3", marginBottom: "20px" },
	chipStyle:
		{ float: "left", padding: "10px", margin: "7px", borderRadius: "40px", border: "1px solid #DFDFDF", backgroundColor: "#DFDFDF", marginTop: "19px" },
	checkboxCSS: {
		color: "#4CAF50",
		'&$checked': {
			color: "#43A047",
		},
	},
	fontSize12: {
		"&:hover": {
			background: "#efefef",
			cursor: "pointer"
		},
	},
	iconCss: {
		maxHeight: "25px",
		maxWidth: "25px",
		marginLeft: "5px",
		marginRight: "5px",
		verticalAlign: "middle",
		zIndex: 9,
	},
	isDefault: {
		color: '#a0522d',
	},
	isGreen: {
		color: '#008000',
	},
	syllabusHead: {
		padding: '6px 8px',
		display: 'flex',
    	alignItems: 'center',
	},
	activeHead: {
		position:'relative',
		backgroundColor: '#f7fafe',
	},
	headof0:{
		position:'relative',
	},
	headLevel0: {
		paddingLeft: '8px',
		'&:before':{
			content : "''",
			display : 'block',
			borderRight :'1px dashed #DDDDDD',	
    		height: '33px',
			position: 'absolute',
			top: '24px',
			left: '39px',

		}
	},
	head: {
		position: 'relative',

	},
	headLevel1: {
		paddingLeft: '29px',
		
		'&:before':{
			content : "''",
			display : 'block',
			borderRight :'1px dashed #DDDDDD',	
    		height: '73%',
			position: 'absolute',
			top: '30px',
			left: '60px',
			zIndex: 9
		},
		'&:after':{
			content : "''",
			display : 'block',
			borderBottom :'1px dashed #DDDDDD',
			position: 'absolute',
			top: '20px',
			left: '41px',
    		width: '12px',
		}
	},
	headLevel2: {
		paddingLeft: '55px',
		cursor: 'pointer',
		'& > svg': {
			fontSize: '12px',
			zIndex: 10,
		},
		'&:after':{
			content : "''",
			display : 'block',
			borderBottom :'1px dashed #DDDDDD',
			position: 'absolute',
			top: '20px',
			left: '66px',
    		width: '12px',
		},
		position: 'relative',
	},
	headlevelConcept:{
		position: 'relative',
		paddingLeft: '27px',
		// '&:before':{
		// 	content : "''",
		// 	display : 'block',
		// 	borderRight :'1px dashed #DDDDDD',	
    	// 	height: '100%',
		// 	position: 'absolute',
		// 	top: '-13px',
		// 	left: '60px',
		// }
	},
	headConceptBorder:{
		'&:after':{
			content : "''",
			display : 'block',
			borderBottom :'1px dashed #DDDDDD',
			position: 'absolute',
			top: '17px',
			left: '60px',
			width: '12px',
			zIndex: 8,
			
		},
		position: 'relative',
	},
	headLevel3: {
		paddingLeft: '40px',
		cursor: 'pointer',
		'& > svg': {
			fontSize: '12px',
		},
		
		
	},
	textWithImg:{
		paddingLeft: '5px',
	},
	width100: {
		width: "100%"
	},
	center: {
		maxWidth: "315px",
		textAlign: "center"
	},
	img: {
		width: "100%"
	},
	button: {
		marginTop: "25px"
	},
	checked: {},
	secondaryHeading: {
		fontSize: theme.typography.pxToRem(15),
		color: theme.palette.text.secondary,
		lineHeight: "40px",
	},
	primaryHeading: {
		flexBasis: '33.33%',
		flexShrink: 0,
	},
	circleLive:{
		background:"#864949",
		width: "14px",
		height: "14px",
		borderRadius: "50%",
		float:"left",
		marginTop:"7px"
	},
	roundIconcss:{
		fontSize:"10px",
			
	},
	rightIcon:{
		float: "right",
		position: "absolute",
		right: "20px",
		marginTop:"7px"
	},
	rightIconIMG:{
		height:"22px",
		width:"22px"
	},
	activeSelected :{
		 backgroundColor: "#2E93FB!important"
	},
	deleteSubmilestone:{
		top:"-8px",
		position: "relative"

	}
});